// extracted by mini-css-extract-plugin
export default {"content-btn":"HomePage_content-btn__+TPCZ","content-btn__item":"HomePage_content-btn__item__U3LGs"};